import { Directive, ElementRef, Input, EventEmitter, OnChanges, HostListener, Output, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[agprElementOverflowParent]',
    standalone: false
})
export class ElementOverflowParentDirective implements AfterViewInit, OnChanges {
    // Event emitted when checking if any elements are in overflow of its parent
    @Output() isOverflowChange: EventEmitter<boolean>;
    @Output() lastVisibleElementIndex: EventEmitter<number>;

    /** Just here to watch for changes on the contents so it can trigger checking for overflow */
    @Input() elements: any;

    bottomPixelPositionOfCollapsedList: number = -1;
    isOverflow: boolean = false;
    lastVisibleElement: number = -1;

    /**
     * Constructor for directive
     */
    constructor(private elementList: ElementRef) {
        this.isOverflowChange = new EventEmitter();
        this.lastVisibleElementIndex = new EventEmitter();
    }

    /**
     * Listens for window resize and checks if component has elements in overflow
    */
    @HostListener('window:resize') onResize() {
        this.checkForOverflow();
    }

    /**
     * Calculates if elements are in overflow of the parent container on input changes
     */
    ngOnChanges() {
        setTimeout( () => {
            // setTimeout allows the check for overflow to be done after the elements are rendered
            this.checkForOverflow();
        }, 0);
    }

    ngAfterViewInit(): void {
        // HACK: SOME cases.. the chips are not rendered yet, so we still want the initial check above to render
        // but we will do another harmless check half a second later for the odd use case where it doesn't work
        setTimeout( () => {
            this.checkForOverflow();
        }, 500);
    }

    /**
     * Iterates over list of elements and checks if each one is in overflow of parent container
     */
    checkForOverflow(): void {
        if (this.elementList) {
            this.isOverflow = false;
            this.lastVisibleElement = -1;
            for (let i = 0; i < this.elementList.nativeElement.children.length; i++) {
                if (this.checkIfListItemIsInOverflow(i)) {
                    this.isOverflow = true;
                    this.lastVisibleElement = i - 1;
                    break;
                }
            }
            this.isOverflowChange.emit(this.isOverflow);
            this.lastVisibleElementIndex.emit(this.lastVisibleElement);
        }
    }

    /**
     * Checks if a specific list item is in overflow of its parent. By calculating the bottom
     * position of the parent and the top position of child and comparing difference
     *
     * @param index index of item in list
     *
     * @returns boolean
     */
    checkIfListItemIsInOverflow(index: number): boolean {
        const listItem = this.elementList.nativeElement.children[index];
        let isElementInOverflow = false;

        if (this.bottomPixelPositionOfCollapsedList === -1) {
            const bottomOfList = this.elementList.nativeElement.clientTop + this.elementList.nativeElement.clientHeight;
            isElementInOverflow = (bottomOfList - listItem.offsetTop) <= 0;
            this.bottomPixelPositionOfCollapsedList = isElementInOverflow ? bottomOfList : -1;
        } else {
            const bottomOfList = this.bottomPixelPositionOfCollapsedList;
            isElementInOverflow = (bottomOfList - listItem.offsetTop) <= 0;
        }
        return isElementInOverflow;
    }
}
